import { MetaImageResponse } from '@/model';
import { localizeContentResponse } from '@/services/useMeta/utils';
import { type CMSContent, useContents, useStructures } from '@/core';
import useGql from '@/services/useGql';

const { getObjectById } = useContents();
const { getStructuresBySlugPath } = useStructures();
const { fetchObject } = useGql();

export const fetchContent = async <T = MetaImageResponse>(slug: string, language?: string): Promise<CMSContent<T>> => {
  if (!slug) return;

  const structure = getStructuresBySlugPath(slug);

  if (structure?.contentId) {
    await fetchObject(structure.contentId, language);
    return localizeContentResponse<T>(getObjectById(structure.contentId, language));
  }
};
